import { useState } from "react";
import { useNavigate, useSearchParams, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500">…</div>;
  if (user) return <Navigate to={user.role === "client" ? "/portal" : next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email.trim(), password);
      toast.success(`Welcome${u.name ? `, ${u.name}` : ""}`);
      navigate(u.role === "client" ? "/portal" : next, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="label-tiny mb-2">Rodeo Cut Studio</div>
          <h1 className="font-display uppercase text-4xl font-bold">Sign In</h1>
        </div>
        <form onSubmit={submit} className="space-y-4 border border-stone-800 p-6">
          <div>
            <div className="label-tiny mb-1">Email</div>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="field-input w-full"
              data-testid="login-email"
            />
          </div>
          <div>
            <div className="label-tiny mb-1">Password</div>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="field-input w-full"
              data-testid="login-password"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-center text-xs text-stone-500 mt-4">
          New here?{" "}
          <Link to="/signup" className="text-orange-400 hover:text-orange-300" data-testid="login-goto-signup">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
